import React, { useState, useEffect, useCallback } from 'react';
import { format } from 'date-fns';
import {
  Container, Box, Grid, Typography, Button, FormControl, Dialog, DialogTitle, DialogContent, TextField, Alert, IconButton, Paper, FormControlLabel, Checkbox, MenuItem, Select, InputLabel,Tooltip
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import BoardCard from '../Components/CardComponents/BoardCard';
import { useParams } from 'react-router-dom';
import { createBoard, fetchBoards, updateBoard, deleteBoard, createTemplate, fetchAssignedGroupsByEmail, fetchUserDetails, fetchProjectDetails, fetchUserGroups,fetchUserGroupsByTenant, fetchTemplates, saveBoard, updateAllBoardsWithWithdrawnColumn } from '../DatabaseApis/DBQuery'; // Adjust the import path
import SideDrawer from '../Components/newcomponents/SideDrawer';
import Navbar from '../Components/LandingComponent/Navbar'; // Adjust the import path

import {
  collection, addDoc, updateDoc, deleteDoc, getDoc, doc, getDocs, query, limit, where, startAfter, writeBatch
} from "firebase/firestore";
import { db } from '../Components/auth/firebaseConfig';
import { useNavigate } from 'react-router-dom';
// import { jwtDecode } from 'jwt-decode';
import AddTemplateDialog from './AddTemplateDialog';
// import ImportCardsDialog from '../Components/ImportCardsDialog';
import { getCookie, removeCookie } from '../utils/cookieUtils';
import Column from '../Components/Column';
import { getSuperAdminEmails } from '../utils/superAdminUtils';

const SprintPage = () => {
  const { projectId } = useParams();
  const [userId, setUserId] = useState();
  const [boards, setBoards] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [newBoard, setNewBoard] = useState({ boardName: '', boardDescription: '', isPublic: true, assignedGroups: [], boardType: 'Sprint', sprintStatus: 'New' });
  const [projectDueDate, setProjectDueDate] = useState(''); // New state to hold project due date
  const [editMode, setEditMode] = useState(false);
  const [boardToEdit, setBoardToEdit] = useState(null);
  // const [showAlert, setShowAlert] = useState(false);
  const [loading, setLoading] = useState(false);
  const [prjName, setPrjName] = useState('');
  const [userGroups, setUserGroups] = useState([]);
  const [lastVisible, setLastVisible] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [boardUpdatedOn, setBoardUpdatedOn] = useState('');
  const [boardActiveStatus, setBoardActiveStatus] = useState(true);  // Default to true
  const [showAlert, setShowAlert] = useState(false);
  const [boardToDelete, setBoardToDelete] = useState(null);
  const [assignedGroups, setAssignedGroups] = useState([]);
  // Retrieve user data from session storage
  const userData = getCookie('userData');
  // const userAssignedGroups = userData?.assignedGroups || [];
  // const userRole = userData ? userData.role : null;
  const [projectStartDate, setProjectStartDate] = useState('');
  // const decodedToken = jwtDecode(userData.token);
  // const userRole = decodedToken.role;
  // const tenantId = decodedToken.tenantId;
  // const email = decodedToken.email;
  const [email, setEmail] = useState('');
  const [tenantId, setTenantId] = useState('');
  const [userRole, setUserRole] = useState('');
  // const [isTemplateDialogOpen, setTemplateDialogOpen] = useState(false);
  const [templates, setTemplates] = useState([]);  // State to hold templates
  // const [selectedTemplate, setSelectedTemplate] = useState('ZppFzGexYOwrN9stfIGO'); // State for selected template
  const [openTemplateDialog, setOpenTemplateDialog] = useState(false);
  const navigate = useNavigate();
  // const userId = userData?.userId;
  const uniqueBoards = boards.filter((board, index, self) =>
    index === self.findIndex((b) => b.id === board.id)
  );

  const superadminEmails = getSuperAdminEmails();

  const isSuperAdmin = superadminEmails.includes(userData.email.toLowerCase());

  // Define a basic handleLogout function
  const handleLogout = () => {
    setIsAuthenticated(false);
    removeCookie('userData');
  };

  useEffect(() => {
    const getUserDetails = async () => {
      const userData = getCookie('userData');
      const token = userData?.token;

      if (!token) {
        console.error('Token not found in cookies');
        return;
      }

      try {
        const data = await fetchUserDetails(token);
        console.log(data);
        console.log(data.email);
        console.log(data.tenantId);
        console.log(data.role);
        setEmail(data.email);
        setTenantId(data.tenantId);
        setUserRole(data.role);
      } catch (error) {
        console.error('Error fetching user details:', error);
      }
    };

    getUserDetails();
  }, []);

  const getAssignedGroups = useCallback(async () => {
    const result = await fetchAssignedGroupsByEmail(email);
    setUserId(result.userId);
    return result.assignedGroups;
  }, [email]);

  useEffect(() => {

    getAssignedGroups();

  }, [email]);

  const loadBoards = useCallback(async () => {
    if (!projectId || loading || boards.length > 0) return; // Skip if already loaded or in the middle of a request
    setLoading(true);
    let retries = 3; // Retry count
    const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

    const fetchWithRetry = async () => {
      while (retries > 0) {
        try {
          let groups = assignedGroups;
          if (groups.length === 0) {
            groups = await getAssignedGroups();
            setAssignedGroups(groups);
          }
          // --- Optimized Firestore query for Sprint boards only ---
          const boardsQuery = query(
            collection(db, 'boards'),
            where('boardType', '==', 'Sprint'),
            where('projectId', '==', projectId)
          );
          const boardsSnap = await getDocs(boardsQuery);
          const boardsData = boardsSnap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
          // ...existing logic...
          if (boardsData.length > 0) {
            setBoards(prevBoards => [...prevBoards, ...boardsData]);
            break; // Break on success
          }
          retries--;
          if (retries > 0) await delay(1000); // Wait before retrying
        } catch (error) {
          console.error('Error fetching boards: ', error);
          retries--;
          if (retries > 0) await delay(1000); // Wait before retrying
        }
      }
    };

    await fetchWithRetry();
    setLoading(false);
  }, [projectId, tenantId, loading, getAssignedGroups, email, assignedGroups, boards.length]);

  const loadPrjName = useCallback(async () => {
    const projectData = await fetchProjectDetails(projectId);

    if (projectData) {
      setPrjName(projectData.prjName);
      setProjectDueDate(projectData.dueDate);
      setProjectStartDate(projectData.startDate);
    }
  }, [projectId]);

  const loadUserGroups = useCallback(async () => {
    try {
      const groupsData = await fetchUserGroupsByTenant(tenantId);
      setUserGroups(groupsData);
    } catch (error) {
      console.error("Error loading user groups:", error);
    }
  }, [tenantId]);

  useEffect(() => {
    if (tenantId) {
      loadBoards();
      loadPrjName();
      loadUserGroups();
      // Update all existing boards with the Withdrawn column
      updateAllBoardsWithWithdrawnColumn(tenantId);
    }

  }, [tenantId, loadPrjName, loadUserGroups]);

  useEffect(() => {
    const loadTemplates = async () => {
      try {
        const templateList = await fetchTemplates(tenantId);
        setTemplates(templateList);
      } catch (error) {
        console.error("Error loading templates:", error);
      }
    };

    loadTemplates();
  }, []);

  const handleOpenDialog = (board = null) => {
    if (board) {
      setEditMode(true);
      setBoardToEdit(board);
      setNewBoard({
        boardName: board.boardName,
        boardDescription: board.boardDescription || '',
        boardType: 'Sprint',
        sprintStatus: board.sprintStatus || 'New',
        // boardType: board.boardType === 'General' || board.boardType === 'Sprint' ? board.boardType : 'General',
        // assignedGroups: board.assignedGroups || [],
        assignedGroups: assignedGroups,
        boardDueDate: board.boardDueDate || projectDueDate, // Use project due date as default
      });
    } else {
      setEditMode(false);
      setNewBoard({
        boardName: '',
        boardDescription: '',
        assignedGroups: assignedGroups,
        boardType: 'Sprint',
        sprintStatus: 'New',
        // boardType: boardType, //Sets the board type based on onClick button
      });
    }
    setDialogOpen(true);
  };

  const handleCloseDialog = () => {
    setDialogOpen(false);
    setBoardToEdit(null);
    setNewBoard({ boardName: '', boardDescription: '', assignedGroups: assignedGroups, boardType: 'General', });
  };

  const handleSaveBoard = async () => {
    if (!projectId) {
      setShowAlert(true);
      return;
    }

    try {
      // If it's a Sprint board, copy columns from General board
      if (newBoard.boardType === 'Sprint') {
        const generalBoard = boards.find(b => b.boardType === 'General' && b.projectId === projectId);
        newBoard.columns = generalBoard ? generalBoard.columns : ['New', 'In-Progress', 'Complete', 'Cancelled'];
      }
      const savedBoard = await saveBoard({
        projectId,
        newBoard,
        // selectedTemplate,
        prjName,
        boardToEdit,
        boardActiveStatus,
        projectDueDate,
        userGroups,
        tenantId,
        userId,
      });

      if (editMode && boardToEdit) {
        setBoards(boards.map((board) => (board.id === boardToEdit.id ? savedBoard : board)));
      } else {
        setBoards([...boards, savedBoard]);
      }

      handleCloseDialog();
    } catch (error) {
      console.error("Error saving board: ", error);
    }
  };

  const handleOpenTemplateDialog = () => {
    setOpenTemplateDialog(true);
  };

  // Function to handle closing the Add Template dialog
  const handleCloseTemplateDialog = () => {
    setOpenTemplateDialog(false);
  };
  const handleSaveTemplate = async (templateData) => {
    // const templateData = {
    //   templateName: "New Template", // Replace with user-defined template name if needed
    //   columns,
    //   createdAt: new Date(),
    // };
    const { templateName, columns } = templateData;

    try {
      await createTemplate(templateData, tenantId, userId); // Replace with actual tenantId and userId
      console.log('Template saved successfully!');
      // handleCloseTemplateDialog();
      setOpenTemplateDialog(false); // Close dialog after saving
    } catch (error) {
      console.error('Error saving template:', error);
    }
  };
  //NOT GETTING CALLED
  {/*
  const handleRemoveCardFromSprint = async (cardId, sprintBoardId) => {
    if (!cardId || !sprintBoardId) {
      console.error('Missing cardId or sprintBoardId');
      return;
    }
    const cardRef = doc(db, "cards", cardId);
    const cardSnap = await getDoc(cardRef);
    if (!cardSnap.exists()) {
      console.error("Card not found.");
      return;
    }
    const cardData = cardSnap.data();
    const updatedSprints = (cardData.assignedSprints || []).filter(s => s.boardId !== sprintBoardId);
    await updateDoc(cardRef, { assignedSprints: updatedSprints });
  }; 
  */}

  const handleDeleteClick = (boardId) => {
    setBoardToDelete(boardId);
    setShowAlert(true); // Show the alert when delete is clicked
  };

  const confirmDelete = async () => {
    if (boardToDelete) {
      try {
        await deleteBoard(boardToDelete, tenantId);
        setBoards(boards.filter(board => board.id !== boardToDelete));
      } catch (error) {
        console.error('Error deleting board: ', error);
      } finally {
        setShowAlert(false);
        setBoardToDelete(null); // Clear the state after deletion
      }
    }
  };

  const handleBoardSelect = (boardId) => {
    // Navigate to the DashboardPage for the selected project
    navigate(`/card-page/${boardId}`);
  };

  return (
    <>
      <Navbar handleLogout={handleLogout} isAuthenticated={isAuthenticated} />
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
        mt={10.3}
        px={2}
        sx={{ backgroundColor: '#007bff', padding: '10px' }}
      >
        <Typography variant="h3" sx={{
          marginLeft: '70px',
          fontWeight: 'bold',
          fontSize: '1.25rem',
          color: '#FFFFFF'
        }}>
          SPRINT BOARDS
        </Typography>

        <Box display="flex" gap={2} sx={{ marginRight: '70px' }}>
          {userRole === 'Admin' && (
            <>
              <Button
                variant="contained"
                sx={{ backgroundColor: '#28a745', color: '#fff', '&:hover': { backgroundColor: '#218838' } }} // Using a different color for distinction
                startIcon={<AddIcon />}
                onClick={() => handleOpenDialog()}
              >
                Add Sprint
              </Button>
              {/* <Button
                variant="contained"
                sx={{ backgroundColor: '#28a745', color: '#fff', '&:hover': { backgroundColor: '#218838' } }}
                startIcon={<AddIcon />}
                onClick={() => handleOpenDialog()}
              >
                Add Board
              </Button> */}
            </>
          )}
        </Box>
      </Box>
      {/* Confirmation Alert */}
      {showAlert && (
        <Alert
          severity="warning"
          action={
            <Button color="inherit" onClick={confirmDelete}>
              Confirm
            </Button>
          }
          onClose={() => setShowAlert(false)}
          sx={{ mb: 2, marginLeft: '60px' }}
        >
          Are you sure you want to delete this board?
        </Alert>
      )}

      {/* Background color box for content */}
      <Box sx={{ backgroundColor: '#ffffff', minHeight: '100vh', paddingBottom: 2, mt: -2 }}>
        <Container maxWidth="lg" sx={{ mt: 2 }}>
          <Box sx={{ flexGrow: 1, marginLeft: { xs: 0, sm: -4, md: -6 }, marginTop: { xs: '20px', md: '0' } }}>
            <Grid container spacing={2}>
              <SideDrawer projectId={projectId} />
              {uniqueBoards.filter(board => board.boardType === 'Sprint').map((board) => (
                <Grid item xs={12} sm={6} md={4} lg={2.4} key={board.id}>
                  <Box
                    sx={{
                      padding: '20px',
                      height: '300px',
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'center',
                      backgroundColor: 'transparent',
                      //backgroundColor: '#f0f4ff',
                      boxShadow: 'none',
                      transition: 'transform 0.2s',
                      '&:hover': { transform: 'scale(1.03)' },
                    }}
                    onClick={() => handleBoardSelect(board.id)}
                  >
                    <BoardCard board={board} />
                    {(userRole === 'Admin' || userRole === 'Tenant Admin') && (
                      <Box sx={{ position: 'relative', top: -60, right: 7, display: 'flex', gap: 8 }}>
                        <IconButton onClick={(event) => { event.stopPropagation(); handleOpenDialog(board); }}>
                          <EditIcon color="primary" />
                        </IconButton>
                        <Tooltip title={board.sprintStatus === 'In-Progress' ? "Cannot delete a sprint that is in progress" : "Delete Sprint"}>
                          <span> {/* Span is needed to show tooltip on a disabled button */}
                            <IconButton 
                              onClick={(event) => { event.stopPropagation(); handleDeleteClick(board.id); }}
                              disabled={board.sprintStatus === 'In-Progress'}
                            >
                              <DeleteIcon color={board.sprintStatus === 'In-Progress' ? 'disabled' : 'error'} />
                            </IconButton>
                          </span>
                        </Tooltip>
                        {/* <IconButton onClick={(event) => { event.stopPropagation(); handleDeleteClick(board.id); }}>
                          <DeleteIcon color="error" />
                        </IconButton> */}
                      </Box>
                    )}
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>

          <Dialog open={dialogOpen} onClose={handleCloseDialog}>
            <DialogTitle>{editMode ? 'Edit Sprint' : 'Add New Sprint'}</DialogTitle>
            <DialogContent>
              {/* Board Name */}
              <TextField
                margin="dense"
                label="Sprint Goal"
                type="text"
                fullWidth
                variant="outlined"
                value={newBoard.boardName}
                onChange={(e) => setNewBoard({ ...newBoard, boardName: e.target.value.slice(0, 75) })}
                helperText={`${newBoard.boardName.length}/75`}
                inputProps={{ maxLength: 75 }}
              />
              
              {/* Board Description */}
              <TextField
                margin="dense"
                name="boardDescription"
                label="Sprint Description"
                type="text"
                fullWidth
                variant="outlined"
                value={newBoard.boardDescription}
                onChange={(e) => setNewBoard({ ...newBoard, boardDescription: e.target.value.slice(0, 300) })}
                helperText={`${newBoard.boardDescription.length}/300`}
                inputProps={{ maxLength: 300 }}
              />

              <TextField
                margin="dense"
                label="Board Due Date"
                type="date"
                fullWidth
                InputLabelProps={{ shrink: true }}
                value={newBoard.boardDueDate}
                onChange={(e) => {
                  const selectedDate = new Date(e.target.value);
                  if (selectedDate >= new Date(projectStartDate) && selectedDate <= new Date(projectDueDate)) {
                    setNewBoard({ ...newBoard, boardDueDate: e.target.value });
                  } else {
                    // Optional: You can show an alert or log an error if the date is out of range
                    alert('Please select a date between project start and end date');
                  }
                }}
                inputProps={{
                  min: projectStartDate ? new Date(projectStartDate).toISOString().split('T')[0] : '', // Minimum date
                  max: projectDueDate ? new Date(projectDueDate).toISOString().split('T')[0] : '', // Maximum date
                }}
                style={{
                  backgroundColor: '#f5f5f5',
                  opacity: 0.6, // Apply dimming effect
                }}
              />


              {/* <FormControl fullWidth margin="dense">
                <InputLabel id="boardType-label">Board Type</InputLabel>
                <Select
                  labelId="boardType-label"
                  value={newBoard.boardType || 'General'} 
                  onChange={(e) => setNewBoard({ ...newBoard, boardType: e.target.value })}
                  label="Board Type"
                >
                  <MenuItem value="General">General</MenuItem>

                  <MenuItem value="Sprint">Sprint</MenuItem>
                </Select>
              </FormControl> */}
              <FormControl fullWidth margin="dense" sx={{ marginBottom: 2 }}>
                {/* Adjust marginBottom for space */}
                <InputLabel id="assigned-groups-label">Assigned Groups</InputLabel>
                <Select
                  labelId="assigned-groups-label"
                  id="assigned-groups"
                  label="Assigned Groups"
                  multiple
                  value={newBoard.assignedGroups}
                  // value={Array.isArray(newBoard.assignedGroups) ? newBoard.assignedGroups : []}
                  onChange={(e) => setNewBoard({ ...newBoard, assignedGroups: e.target.value })}
                  MenuProps={{ PaperProps: { sx: { maxHeight: 300 } } }} // Optional: Limit dropdown height
                >
                  {userGroups.map((group) => (
                    <MenuItem key={group.id} value={group.id}>
                      {group.groupName}
                    </MenuItem>
                  ))}
                  {/* {userGroups
                  .filter(group => assignedGroups.includes(group.id))
                  .map((group) => (
                    <MenuItem key={group.id} value={group.id}>
                      {group.groupName}
                    </MenuItem>
            ))}  */}
                </Select>
              </FormControl>  

              <FormControl fullWidth margin="dense">
                    <InputLabel id="sprint-status-label">Sprint Status</InputLabel>
                    <Select
                      labelId="sprint-status-label"
                      value={newBoard.sprintStatus}
                      label="Sprint Status"
                      onChange={(e) => setNewBoard({ ...newBoard, sprintStatus: e.target.value })}
                      // The 'Completed' status cannot be set manually, so it is disabled.
                      // disabled={newBoard.sprintStatus === 'Completed'}
                    >
                      <MenuItem value="New">New</MenuItem>
                      <MenuItem value="In-Progress">In-Progress</MenuItem>
                      <MenuItem value="Completed">Completed</MenuItem>
                      <MenuItem value="Cancelled">Cancelled</MenuItem>                      
                      {/* Conditionally show the Completed option if it's the current status */}
                      {/* {newBoard.sprintStatus === 'Completed' && (
                        <MenuItem value="Completed">Completed</MenuItem>
                      )} */}
                    </Select>
                  </FormControl>
              {/* <FormControl fullWidth margin="normal">
          <InputLabel>Template</InputLabel>
          <Select
            value={selectedTemplate}
            onChange={(e) => setSelectedTemplate(e.target.value)}
            label="Template"
          >
            {templates.map((template) => (
              <MenuItem key={template.id} value={template.id}>
                {template.templateName}
              </MenuItem>
            ))}
          </Select>
        </FormControl> */}

              {/* Save and Cancel Buttons */}

              <Box display="flex" justifyContent="flex-end" mt={2} gap={2}>
                <Button variant="contained"
                  color="primary" onClick={handleSaveBoard} >
                  Save
                </Button>
                <Button onClick={handleCloseDialog} >
                  Cancel
                </Button>
              </Box>
              <AddTemplateDialog
                open={openTemplateDialog}
                onClose={handleCloseTemplateDialog}
                onSave={handleSaveTemplate}
                isSuperAdmin={isSuperAdmin}
              />
            </DialogContent>
          </Dialog>

        </Container>

      </Box>
    </>
  );
};

export default SprintPage;
